import stepCard from "../components/steps/stepCard";

export default {
  components: {
    stepCard
  },
  data() {
    return {
      selectedPanel: null
    };
  },
  computed: {},
  methods: {
    lineThrough(bool) {
      return bool ? "text-decoration: line-through" : "";
    },
    getNextStep() {
      var groupStep = this.getGroupSteps();
      if (!groupStep) return;
      var i = this.selectedPanel + 1;
      while (i < groupStep.length) {
        if (!groupStep[i].validated) return i;
        i++;
      }
      return null;
    },
    stepValidated() {
      console.log("close step");
      /* open the next non validated step when a step has been validated */
      this.selectedPanel = this.getNextStep();
    },
    stepIconColor(step) {
      return step.validated ? "#69cb69" : "rgba(0, 0, 0, 0.22)";
    }
  }
};
